<template>
	<div v-if="links.length > 3">
		<div class="flex flex-wrap -mb-1">
			<template 
				v-for="(link, key) in links"
				:key="key"
				>
				<div 
					v-if="link.url === null" 
					class="mr-1 mb-1 px-4 py-3 text-sm leading-4 text-gray-400 border rounded" 
					v-html="link.label" 
					/>
				<Link 
					v-else 
					class="mr-1 mb-1 px-4 py-3 text-sm leading-4 border rounded hover:bg-black hover:text-white" 
					:class="{ 'bg-black text-white': link.active }" 
					:href="strippedLink(link.url)" 
					v-html="link.label" 
					/>
			</template>
		</div>
	</div>
</template>

<script>

import { Link } from "@inertiajs/inertia-vue3";

export default {
	props: {
		links: Array,
	},
	components : {
		Link
	},
	methods: {
		strippedLink(url){
			// this is really only for localhost, it wont make a blind bit of difference on live or staging. But it just makes the pagination work without error when serving through webpack whilst developing.
			return url.replace('https://meshworks-docroom.test/', 'https://localhost:3000/')
		}
	}
}
</script>
